import { render, staticRenderFns } from "./RegularForms.vue?vue&type=template&id=5c51fc9a&scoped=true"
import script from "./RegularForms.vue?vue&type=script&lang=js"
export * from "./RegularForms.vue?vue&type=script&lang=js"
import style0 from "./RegularForms.vue?vue&type=style&index=0&id=5c51fc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51fc9a",
  null
  
)

export default component.exports